import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import "./style.scss";

import { Modal, ModalHeader, ModalBody, Form, Row, Col, FormGroup } from "reactstrap";
import { fetchCaptchaResponse, getGroupList, subscribeRequest } from "../../utils/request";
import { useDispatch } from "react-redux";
import { Button } from "react-bootstrap";

type UserData = {
  email: string;
  fname: string;
  group_id: string;
  group_name: string;
};
type SubscriptionModel = {
  userDetails: UserData;
  onClosed: () => void;
  handleChange: (e: any) => void;
  resetForm: () => void;
  isOpen: boolean;
};

const SubscriptionModal = ({ userDetails, onClosed, handleChange, resetForm, isOpen }: SubscriptionModel) => {
  const [categories, setCategories] = useState<any[]>([]);
  const [touched, setTouched] = useState<boolean>(false);
  const [isSubmittable, setIsSubmittable] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetch = async () => {
      const groups = await getGroupList();
      setCategories(groups);
    };
    fetch();
  }, []);

  const newsletterSubscribeRequest = async (userData: UserData, closeModal: () => void) => {
    setIsLoading(true);
    const data = await subscribeRequest(userData);
    if (data) {
      dispatch({ type: "SUBSCRIBED", payload: null });
      data.status && toast.success("Subscribed!");
      setTouched(false);
      setIsSubmittable(false);
      resetForm();
      closeModal();
    }
    setIsLoading(false);
  };

  const formIsValid = userDetails?.group_id && userDetails?.email && userDetails?.fname;

  const submitHandler = (e: any) => {
    e.preventDefault();
    setTouched(true);
    formIsValid && newsletterSubscribeRequest(userDetails, onClosed);
  };

  const toggle = () => {
    setIsSubmittable(false);
    onClosed();
  };

  const verifyCaptcha = useCallback(
    async (token: string | null) => {
      if (!token) {
        setIsSubmittable(false);
        return;
      }
      const data = await fetchCaptchaResponse(token);
      if (data?.status) {
        setIsSubmittable(true);
      } else if (data?.status !== undefined) {
        toast.error("Failed!");
      }
    },
    [isSubmittable],
  );

  return (
    <Modal size="sm" isOpen={isOpen} backdrop={!isLoading} onClosed={toggle} toggle={toggle} className="signupModalWrap">
      <ModalHeader>
        <i
          className="fa fa-times"
          onClick={() => {
            !isLoading && onClosed();
          }}
        ></i>
        <span>Keep up with the</span>
        Clarity Cooperative
      </ModalHeader>
      <Form onSubmit={submitHandler}>
        <ModalBody>
          <h4>Subscribe to our newsletter & receive details on upcoming resources and discounts.</h4>
          <p>Sign up for our newsletter now and receive updates about the resources.</p>
          <Row className="my-2">
            <Col sm={12}>
              <FormGroup>
                <label className="d-block mb-2">Kindly choose the category which you want to subscribe*</label>
                <div className="d-flex align-items-center flex-wrap">
                  {categories.map((category) => {
                    return (
                      <div className="d-flex align-items-center form-check form-check-inline" key={category.id}>
                        <input
                          className="form-check-input mouse-pointer"
                          type="radio"
                          name="group_name"
                          id={category.id}
                          value={category.name}
                          onChange={handleChange}
                          checked={category.id === userDetails?.group_id}
                        />
                        <label className="form-check-label " htmlFor={category.id}>
                          {category.name}
                        </label>
                      </div>
                    );
                  })}
                </div>
                {touched && !userDetails?.group_id && !userDetails?.group_name && (
                  <p style={{ color: "red" }} className="cat-error">
                    please select category
                  </p>
                )}
              </FormGroup>
            </Col>
            <Col sm={12} style={{ pointerEvents: !userDetails.group_id ? "none" : "auto" }}>
              <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY || ""} onChange={verifyCaptcha} />
            </Col>
          </Row>
          <Button type="submit" variant="success" disabled={!isSubmittable || isLoading}>
            Send It {!isLoading ? <i className="fa fa-paper-plane ml-1" /> : <i className="fa-solid fa-circle-notch fa-spin" />}{" "}
          </Button>{" "}
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default SubscriptionModal;
